import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { DataTable, columnTypes as colType, catcherAccuracyScore, percent } from 'yankees-react-utils';

const columns = (translate) => [
    { id: 'name', title: translate('sections.reports.catcher.throwing.2b-straight-steals'), transform: (row) => row.name, type: colType.TEXT },
    {
        id: 'accuracy',
        title: translate('sections.reports.catcher.throwing.accuracy'),
        transform: (row) => {
            if (row.throws2bwloc) {
                return catcherAccuracyScore(row.throws2bwloc, row.greatthrows2b, row.goodthrows2b, 2);
            }
            if (row.throws) {
                return catcherAccuracyScore(row.throws, row.greatthrows, row.goodthrows, 2);
            }
            return null;
        },
        precision: 2,
    },
    { id: 'velo', title: translate('sections.reports.catcher.throwing.throw-velo'), transform: (row) => row.throwvelo, precision: 2 },
    { id: 'poptime', title: translate('sections.reports.catcher.throwing.pop-time'), transform: (row) => row.catchertime, precision: 2 },
    { id: 'exchangetime', title: translate('sections.reports.catcher.throwing.exchange-time'), transform: (row) => row.transfertime, precision: 2 },
    { id: 'throwtime', title: translate('sections.reports.catcher.throwing.throw-time'), transform: (row) => row.throwtime, precision: 2 },
    { id: 'bounceperc', title: translate('sections.reports.catcher.throwing.bounce-pct'), transform: (row) => percent(row.bounces / row.attempts), type: colType.TEXT },
    { id: 'attempts', title: translate('sections.reports.catcher.throwing.num-attempts'), transform: (row) => (!row.islgavg ? row.attempts : '--') },
    { id: 'throws', title: translate('sections.reports.catcher.throwing.num-throws'), transform: (row) => (!row.islgavg ? row.throws : '--') },
];

const ThrowingTable = ({ player, catcherData, lgavgData }) => {
    const { t: translate } = useTranslation();
    const rows = [{ ...catcherData, name: player.FullName, islgavg: false }, { ...lgavgData, name: translate('sections.reports.catcher.throwing.mlb-avg'), islgavg: true }];
    return (<DataTable columns={columns(translate)} rows={rows} />);
};

ThrowingTable.propTypes = {
    player: PropTypes.shape({
        PlayerID: PropTypes.number,
        FullName: PropTypes.string,
    }).isRequired,
    catcherData: PropTypes.shape({
        catcherTime: PropTypes.number,
        throws2bwloc: PropTypes.number,
        greatthrows2b: PropTypes.number,
        goodthrows2b: PropTypes.number,
        transfertime: PropTypes.number,
        throwtime: PropTypes.number,
        bobbles: PropTypes.number,
        attempts: PropTypes.number,
        throws: PropTypes.number,
    }).isRequired,
    lgavgData: PropTypes.shape({
        catcherTime: PropTypes.number,
        throws2bwloc: PropTypes.number,
        greatthrows2b: PropTypes.number,
        goodthrows2b: PropTypes.number,
        transfertime: PropTypes.number,
        throwtime: PropTypes.number,
        bobbles: PropTypes.number,
        attempts: PropTypes.number,
        throws: PropTypes.number,
    }).isRequired,
};

export default ThrowingTable;
